import { Box, Container } from '@mui/material';
import { DELETE_GRADE, LIST_GRADES, CREATE_GRADE, UPDATE_GRADE } from "../../../graphql/admin-requests";
import React from 'react';
import GradeListResults from './GradeListResults';
import EntityListToolbar from '../subcomponents/EntityListToolbar';
import { useEntityList } from '../../../hooks/useEntityList';
import CUSimpleItem from "../CreateUpdateComponents/SimpleItem";


function GradeList() {

    const {
        items: grades,
        totalCount,
        limit,
        setLimit,
        offset,
        setOffset,
        updateSearch,
        loadData,
        handleDelete: handleDeleteGrade,
    } = useEntityList({
        listQuery: LIST_GRADES,
        listDataKey: "allGrades",
        deleteMutation: DELETE_GRADE,
        deleteVariableName: "gradeUid",
        deleteErrorMessage: "Impossible de supprimer le niveau",
        deleteSuccessMessage: "Niveau supprimé",
    });

    return (
        <Container component="main">
            <Box sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 3 }}>
                <Container maxWidth={false}>
                    <EntityListToolbar
                        loadData={loadData}
                        updateSearch={updateSearch}
                        searchPlaceholder="Rechercher un niveau"
                        CreateComponent={CUSimpleItem}
                        createComponentProps={{ createRequest: CREATE_GRADE, updateRequest: UPDATE_GRADE, itemName: "niveau" }}
                    />
                    <Box sx={{ pt: 3 }}>
                        <GradeListResults
                            grades={grades}
                            limit={limit}
                            offset={offset}
                            totalCount={totalCount}
                            setLimit={setLimit}
                            setOffset={setOffset}
                            loadData={loadData}
                            handleDeleteGrade={handleDeleteGrade} />
                    </Box>
                </Container>
            </Box>
        </Container >
    )
};

export default GradeList;
